import { SystemKeys } from 'consts/cachedKey';
import { useStore as storeZustand, useGet } from 'redux/store/StoreCached';

class CheckBalanceModel {
  checkIsNotEnoughCredits() {
    const hasNotEnoughCredits = useGet(SystemKeys.IS_NOT_ENOUGH_CREDITS);
    return hasNotEnoughCredits;
  }

  setIsNotEnoughCredits(boolean) {
    storeZustand.getState().save(SystemKeys.IS_NOT_ENOUGH_CREDITS, boolean);
  }
}

export default new CheckBalanceModel();
